import(/* webpackMode: "eager" */ "/vercel/path0/app/(lobby)/error.tsx");
